var _circle, _path, _path2, _rect, _rect2, _rect3, _path3, _path4, _circle2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepeatPrescriptionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 17,
    fill: "#FCE6EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.07927 11.425V6.475C8.07927 5.13431 7.23449 4 5.53671 4C4.22981 4 3 5.08414 3 6.42483L3 8.69655C3 10.6 2.99005 11.425 4.83747 11.425C5.61193 11.425 6.29887 11.425 8.07927 11.425Z",
    fill: "#276CA4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6926 4H5.56347C5.55578 4 5.54809 4 5.53271 4C6.76299 4.01556 8.07938 5.08133 8.07938 6.33381V34.525C8.07938 35.8164 8.92826 37 10.2047 37H28.6926C29.969 37 30.9993 35.8164 30.9993 34.525V6.33381C30.9993 5.04243 29.969 4 28.6926 4Z",
    fill: "#4DAADD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.1768,
    y: 9.77539,
    width: 13.5822,
    height: 1.65,
    rx: 0.825,
    fill: "#99DDF3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1768,
    y: 13.0747,
    width: 13.5822,
    height: 1.65,
    rx: 0.825,
    fill: "#99DDF3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.7231,
    y: 16.375,
    width: 8.48887,
    height: 1.65,
    rx: 0.825,
    fill: "#99DDF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6002 20.0247C24.7225 18.9064 22.3216 19.57 21.2375 21.507L16.5266 29.9244C15.4425 31.8614 16.0859 34.3382 17.9635 35.4565C19.8412 36.5749 22.2421 35.9112 23.3262 33.9742L28.0371 25.5568C29.1212 23.6198 28.4779 21.143 26.6002 20.0247Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6815 29.7657L28.0369 25.557C29.121 23.6201 28.4777 21.1432 26.6 20.0249C24.7223 18.9066 22.3214 19.5702 21.2373 21.5072L18.8819 25.7159L25.6815 29.7657Z",
    fill: "#FF9E3E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 29.5,
    r: 6.5,
    fill: "#E57200"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_515_936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.297 31.429L30.297 32.7245C30.297 32.8162 30.2418 32.8991 30.1574 32.9351C30.0733 32.9707 29.9749 32.9527 29.9094 32.8885L27.3195 30.3748C27.275 30.3318 27.25 30.2727 27.25 30.2109C27.25 30.149 27.275 30.0899 27.3195 30.0469L29.9094 27.5333C29.9755 27.4693 30.0736 27.4513 30.1574 27.4866C30.2418 27.5226 30.297 27.6055 30.297 27.6972L30.297 28.9921L30.729 28.9921C32.1416 28.9921 33.4439 28.2243 34.1273 26.9897L34.1337 26.9781C34.1745 26.9038 34.2519 26.8593 34.3342 26.8593C34.3531 26.8593 34.372 26.8614 34.3909 26.8663C34.492 26.8922 34.5627 26.9833 34.5627 27.0878C34.5627 29.4564 32.6562 31.3882 30.297 31.429Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_515_936"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.31272,
    height: 7.31252,
    fill: "white",
    transform: "matrix(1 -1.8258e-07 -4.18607e-08 -1 27.25 33.5625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeatPrescriptionIcon);
export default __webpack_public_path__ + "static/media/RepeatPrescriptionIcon.1f8726794c1e89051c45acaa8d6fd97e.svg";
export { ForwardRef as ReactComponent };